<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Orçamentos</h3>
        <d-link class="btn btn-success text-white float-right " href="/admin/orcamentos/novo">Novo orçamento</d-link>
      </div>
    </div>

    <!-- Default Light Table -->
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-around flex-wrap">
            <div class="col-6 col-sm-7 col-md-4 col-lg-6">
              <h6 class="m-0">Orçamentos</h6>
            </div>
            <div class="input-group col-6 col-sm-5 col-md-3 col-lg-2">
              <d-select
                  v-model="pagination.status"
                  :options="statusOptions"
                  value-field="slug"
                  text-field="name"
                >
                </d-select>
            </div>
            <div class="col-12 col-md-5 col-lg-4">
              <form action="#" class="main-sidebar__search w-100 d-flex">
                <div class="input-group input-group-seamless ml-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fas fa-search"></i>
                    </div>
                  </div>
                  <input
                    class="navbar-search form-control"
                    type="text"
                    placeholder="Procurar por algo..."
                    aria-label="Search"
                    v-model="pagination.search"
                  >
                </div>
              </form>
            </div>
          </div>
          <div class="card-body p-0 pb-3">
            <div class="table-overflow">
              <quotation-table :quotations="quotations.list"></quotation-table>
            </div>
            <pagination :total-items="quotations.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import QuotationTable from '../components/QuotationListTable.vue';
import { STATUS_OPTIONS } from '../components/QuotationModel';

export default {
  name: 'quotation-list',
  components: {
    Pagination,
    QuotationTable,
  },
  data() {
    return {
      statusOptions: [{ slug: null, name: 'Filtro por status' }].concat(STATUS_OPTIONS),
      pagination: {
        search: '',
        status: null,
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    quotations() {
      const { quotationList } = this.$store.state.quotation;
      if (quotationList && quotationList.list.length) {
        return quotationList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getQuotationList',
    ]),
    getList() {
      this.setToggle({ type: 'progress', bool: true });
      this.getQuotationList(this.pagination)
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
  },
  beforeDestroy() {
    Events.$off('update:pagination');
  },
};
</script>
